import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export default function Introduction({ description, points=[]}) {
  return (
    <>
        <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:my-8 my-4">
            <p className="font-medium">{description}</p>
            <div>
                <ul>
                {points.map((item, index) => (
                    <li className="flex text-base" key={index}>
                        <div className="pr-4">
                            <FontAwesomeIcon icon={faCheck} style={{ color: '#1b5df3', marginRight: '5px' }}/>
                        </div>
                        {item?.pointsItems}
                    </li>
                ))}
                </ul>
            </div>
        </div>
    </>
  )
}

